import defaultPostTypeConfig from '../post'
import capitalize from '../../utils/capitalize'

export default function getConstants(p = {}) {

    const name = 'banner'

    const n = name
    const N = capitalize(n)
    const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'
    const Ns = capitalize(ns)

    const {
        labels,
        menus,
        messages,
        routes,
        titles
    } = defaultPostTypeConfig.getConstants({
        ...p,
        name
    })

    return {
        labels: {
            ...labels,
            ['new' + N + 'SubmitLabel']: 'Mentés',
            ['restore' + N + 'SubmitLabel']: 'Visszaállítás',
            ['save' + N + 'SubmitLabel']: 'Mentés',
            ['cancel' + N + 'Text']: 'Mégsem',
            ['delete' + N + 'Text']: 'Törlés',
            ['delete' + Ns + 'Text']: 'Bannerek törlése',
            ['ban' + N + 'Text']: 'Tiltás',
            ['approve' + N + 'Text']: 'Jóváhagyás',
            ['protection' + N + 'Text']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Text']: 'Védettség megszüntetése',
            ['select' + N + 'Text']: 'Kiválasztás',
            ['add' + N + 'Text']: 'Hozzáadás',
            ['moreFromMy' + Ns + 'Title']: 'További bannereim',
            ['moreFromUser' + Ns + 'Title']: 'További bannerek',

            [ns + 'SortRelevance']: 'Relevancia'
        },
        menus: {
            ...menus,
            ['user' + Ns + 'Menu']: 'Bannerek',
            ['my' + Ns + 'Menu']: 'Bannereim',
            ['new' + N + 'Menu']: 'Új banner',
            [ns + 'Menu']: 'Bannerek',
            ['deleted' + Ns + 'Menu']: 'Törölt bannerek',
            ['banned' + Ns + 'Menu']: 'Véglegesen törölt bannerek',
            ['protection' + Ns + 'Menu']: 'Védett bannerek',
            ['missingData' + Ns + 'Menu']: 'Hiányzó adatok',
            ['lowAuthorStatus' + Ns + 'Menu']: 'Szerző alacsony státusszal',

            ['edit' + N + 'Menu']: 'Szerkesztés',
            ['delete' + N + 'Menu']: 'Törlés',
            ['ban' + N + 'Menu']: 'Tiltás',
            ['approve' + N + 'Menu']: 'Jóváhagyás',
            ['protection' + N + 'Menu']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Menu']: 'Védettség törlése'
        },
        messages: {
            ...messages,
            ['new' + N + 'SuccessMessage']: 'Az új banner mentésre került',
            ['save' + N + 'SuccessMessage']: 'A banner mentésre került',
            ['delete' + N + 'Success']: 'A banner törölve lett',
            ['delete' + Ns + 'Success']: 'A bannerek törölve lettek',
            ['delete' + N + 'Question']: 'Biztosan törli az bannert?',
            ['delete' + Ns + 'Question']: 'Biztosan törli az bannerekat?',
            ['ban' + N + 'Success']: 'A banner véglegesen törölve lett',
            ['ban' + N + 'Question']: 'Biztos, hogy az bannert véglegesen törölni akarod?',
            ['approve' + N + 'Success']: 'A banner jóvá lett hagyva',
            ['approve' + N + 'Question']: 'Biztosan jóváhagyod az bannert',
            ['protection' + N + 'Success']: 'A banner védettnek jelölve',
            ['protection' + N + 'Question']: 'Biztosan védettnek jelölöd az bannert?',
            ['removeProtection' + N + 'Success']: 'A védettnek jelölés törölve lett',
            ['removeProtection' + N + 'Question']: 'Biztosan törlöd a védettnek jelölést?',
            ['thereAreNo' + Ns]: 'Nincsenek bannerek'
        },
        routes: {
            ...routes
        },
        titles: {
            ...titles,
            [n + 'Title']: 'Banner',
            [ns + 'Title']: 'Bannerek',
            ['new' + N + 'Title']: 'Új banner',
            ['edit' + N + 'Title']: 'Banner szerkesztése',
            ['user' + Ns + 'Title']: 'Bannerek',
            ['userDeleted' + Ns + 'Title']: 'Törölt bannerek',
            ['userBanned' + Ns + 'Title']: 'Véglegesen törölt bannerek',
            ['my' + Ns + 'Title']: 'Bannereim',
            ['myDeleted' + Ns + 'Title']: 'Törölt bannereim',
            ['myBanned' + Ns + 'Title']: 'Véglegesen törölt bannereim',

            ['dialogDelete' + N + 'Title']: 'Banner törlése',
            ['dialogBan' + N + 'Title']: 'Banner törlése véglegesen',
            ['dialogApprove' + N + 'Title']: 'Banner jóváhagyása',
            ['dialogProtection' + N + 'Title']: 'Banner védettnek jelölése',
            ['dialogRemoveProtection' + N + 'Title']: 'Banner védettségének megszüntetése',

            ['dialogDelete' + Ns + 'Title']: 'Bannerek törlése',

            ['statusBanned' + N + 'Title']: 'Véglegesen törölt',
            ['statusDeleted' + N + 'Title']: 'Törölt',
            ['statusAuthorDeleted' + N + 'Title']: 'Szerző törölve',
            ['statusMissingData' + N + 'Title']: 'Hiányzó adatok',
            ['statusApproved' + N + 'Title']: 'Jóváhagyott',
            ['statusFeatured' + N + 'Title']: 'Védett',
            ['statusCreated' + N + 'Title']: 'Létrehozva',

            ['banned' + Ns + 'Title']: 'Véglegesen törölt bannerek',
            ['deleted' + Ns + 'Title']: 'Törölt bannerek',
            ['missingData' + Ns + 'Title']: 'Hiányzó adatok',
            ['protected' + Ns + 'Title']: 'Védett bannerek',
            ['lowAuthorStatus' + Ns + 'Title']: 'Szerző alacsony státusszal',

            ['select' + Ns]: 'Bannerek kiválasztása',
            ['select' + N]: 'Banner kiválasztása'
        }
    }
}
